var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    id: "svg9",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3771c8",
    id: "stop1"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771c8",
    offset: 0.128,
    id: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60f",
    stopOpacity: 0,
    id: "stop3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd5",
    id: "stop4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fd5",
    id: "stop5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff543e",
    id: "stop6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c837ab",
    id: "stop7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 158.429,
    cy: 578.08801,
    r: 65,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-1.98198,1.8439,0,-1230.0539,359.90723)",
    fx: 158.429,
    fy: 578.08801
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 147.694,
    cy: 473.45499,
    r: 65,
    xlinkHref: "#b",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.17394,0.86872,-3.5818,0.71718,1648.348,-458.493)",
    fx: 147.694,
    fy: 473.45499
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 48.004,0 C 34.968,0 33.332,0.057 28.212,0.29 c -5.11,0.234 -8.598,1.043 -11.65,2.23 -3.157,1.226 -5.835,2.866 -8.503,5.535 -2.67,2.668 -4.31,5.346 -5.54,8.502 -1.19,3.053 -2,6.542 -2.23,11.65 C 0.06,33.327 0,34.964 0,48 c 0,13.036 0.058,14.667 0.29,19.787 0.235,5.11 1.044,8.598 2.23,11.65 1.227,3.157 2.867,5.835 5.536,8.503 2.667,2.67 5.345,4.314 8.5,5.54 3.054,1.187 6.543,1.996 11.652,2.23 5.12,0.233 6.755,0.29 19.79,0.29 13.037,0 14.668,-0.057 19.788,-0.29 5.11,-0.234 8.602,-1.043 11.656,-2.23 3.156,-1.226 5.83,-2.87 8.497,-5.54 2.67,-2.668 4.31,-5.346 5.54,-8.502 1.18,-3.053 1.99,-6.542 2.23,-11.65 0.23,-5.12 0.29,-6.752 0.29,-19.788 0,-13.036 -0.06,-14.672 -0.29,-19.792 -0.24,-5.11 -1.05,-8.598 -2.23,-11.65 -1.23,-3.157 -2.87,-5.835 -5.54,-8.503 -2.67,-2.67 -5.34,-4.31 -8.5,-5.535 C 76.379,1.333 72.889,0.524 67.779,0.29 62.659,0.057 61.029,0 47.989,0 Z m -4.306,8.65 c 1.278,-0.002 2.704,0 4.306,0 12.816,0 14.335,0.046 19.396,0.276 4.68,0.214 7.22,0.996 8.912,1.653 2.24,0.87 3.837,1.91 5.516,3.59 1.68,1.68 2.72,3.28 3.592,5.52 0.657,1.69 1.44,4.23 1.653,8.91 0.23,5.06 0.28,6.58 0.28,19.39 0,12.81 -0.05,14.33 -0.28,19.39 -0.214,4.68 -0.996,7.22 -1.653,8.91 -0.87,2.24 -1.912,3.835 -3.592,5.514 -1.68,1.68 -3.275,2.72 -5.516,3.59 -1.69,0.66 -4.232,1.44 -8.912,1.654 -5.06,0.23 -6.58,0.28 -19.396,0.28 -12.817,0 -14.336,-0.05 -19.396,-0.28 -4.68,-0.216 -7.22,-0.998 -8.913,-1.655 -2.24,-0.87 -3.84,-1.91 -5.52,-3.59 -1.68,-1.68 -2.72,-3.276 -3.592,-5.517 -0.657,-1.69 -1.44,-4.23 -1.653,-8.91 -0.23,-5.06 -0.276,-6.58 -0.276,-19.398 0,-12.818 0.046,-14.33 0.276,-19.39 0.214,-4.68 0.996,-7.22 1.653,-8.912 0.87,-2.24 1.912,-3.84 3.592,-5.52 1.68,-1.68 3.28,-2.72 5.52,-3.592 1.692,-0.66 4.233,-1.44 8.913,-1.655 4.428,-0.2 6.144,-0.26 15.09,-0.27 z m 29.928,7.97 c -3.18,0 -5.76,2.577 -5.76,5.758 0,3.18 2.58,5.76 5.76,5.76 3.18,0 5.76,-2.58 5.76,-5.76 0,-3.18 -2.58,-5.76 -5.76,-5.76 z m -25.622,6.73 c -13.613,0 -24.65,11.037 -24.65,24.65 0,13.613 11.037,24.645 24.65,24.645 C 61.617,72.645 72.65,61.613 72.65,48 72.65,34.387 61.616,23.35 48.003,23.35 Z m 0,8.65 c 8.836,0 16,7.163 16,16 0,8.836 -7.164,16 -16,16 -8.837,0 -16,-7.164 -16,-16 0,-8.837 7.163,-16 16,-16 z",
    id: "path9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.0d25539ea5190f5396df8041d977d64f.svg";
export { ForwardRef as ReactComponent };